import http from "./http";

class AdminService {


    reversement(data,token) {
        return http.post("/api/ventes/reversement/operation", data,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    listeReversements(token) {
        return http.get("/api/ventes/reversement",{ headers: { 'Authorization': 'Bearer '+token } })
    }
 
    dashboard(token) {
        return http.get("/api/dashboard",{ headers: { 'Authorization': 'Bearer '+token } })
    }
 
}

export default new AdminService